<template>
  <div class="flex flex-col">
    <div class="flex flex-row p-2">
      <span class="text-md font-bold border-b border-gray-600">{{ weekdayDisplay }}</span>
    </div>
    <div class="grid grid-cols-5 p-2"
      v-if="scheduleData == undefined || scheduleData.trips == undefined">
      <div class="bg-white !shadow rounded-md py-2 px-3 text-lg mb-40">
        <div class="text-xl mb-3">No Trip For Day</div>
      </div>
    </div>
    <div class="flex flex-row w-full overflow-x-auto p-2 gap-2"
      v-else>
      <div
        v-for="trip in tripsOrdered"
        :key="trip.dbId">
        <HighlightChange class="p-2"
          v-if="trip.type === 'inbound'"
          :changeType="highlightTrip(scheduleDataDiff?.trips?.inbound)">
          <TripInbound
            :tripData="trip"
            :tripDataDiff="scheduleDataDiff?.trips?.inbound"
            :selectedDate="calculateSelectedDate"
          />
        </HighlightChange>
        <HighlightChange class="p-2"
          v-if="trip.type === 'outbound'"
          :changeType="highlightTrip(scheduleDataDiff?.trips?.outbound)">
          <TripOutbound
            :tripData="trip"
            :tripDataDiff="scheduleDataDiff?.trips?.outbound"
            :selectedDate="calculateSelectedDate"
          />
        </HighlightChange>
        <HighlightChange class="p-2"
          v-if="trip.type === 'shuttle'"
          :changeType="highlightTrip(scheduleDataDiff?.trips?.shuttle)">
          <TripShuttle
            :tripData="trip"
            :tripDataDiff="scheduleDataDiff?.trips?.shuttle"
            :selectedDate="calculateSelectedDate"
          />
        </HighlightChange>
      </div>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import scheduleUtil from '../../../services/utils/schedule.js'

import HighlightChange from '../utilities/HighlightChange.vue'

import TripInbound from './trips/TripInbound.vue'
import TripOutbound from './trips/TripOutbound.vue'
import TripShuttle from './trips/TripShuttle.vue'

const WEEKDAY_CODES = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
]

export default {
  components: {
    HighlightChange,
    TripInbound,
    TripOutbound,
    TripShuttle,
  },
  props: {
    weekdayCode: String,
    scheduleData: {
      type: Object,
      default: undefined,
    },
    scheduleDataDiff: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      tripOrderByTypes: ['empty', 'inbound', 'outbound', 'shuttle'],
    }
  },
  methods: {
    highlightTrip(diffObj) {
      let retVal = scheduleUtil.mapDiffObject(diffObj)
      if (retVal === 'add' || retVal === 'remove') {
        return retVal
      }
      else {
        return undefined
      }
    },
  },
  computed: {
    weekdayDisplay() {
      let map = {
        sun: 'Sunday',
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
      }

      return map[this.weekdayCode]
    },
    calculateSelectedDate() {
      let indexWeekday = WEEKDAY_CODES.indexOf(this.weekdayCode)
      let newDate = new Date()
      newDate.setDate(newDate.getDate() + (indexWeekday + (7 - newDate.getDay())) % 7)
      return newDate.toISOString().substring(0, 10)
    },
    tripsOrdered() {
      return sortBy(this.scheduleData.trips, [(elem) => {
        return this.tripOrderByTypes.findIndex((tripType) => {
          return tripType === elem.type
        })
      }])
    },
  },
}
</script>
